module.exports = require('./helpers/bundle-url').getBundleURL('i4114') + "sharetargetsw.js";